import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { url } from 'src/config';
import { orgId } from 'src/constants';
import { alertSuccess, alertError } from './alert';
import { fetchUser } from './auth';
import { isLoading } from './isLoading';

const initialState = {
  history: [],
  beneficiary: [],
  fetchRates: []
};

const current_store = JSON.parse(window.localStorage.getItem('current_store'));

const current_vzid = current_store && current_store.current_vzid;

const slice = createSlice({
  name: 'transferCredit-Rates',
  initialState,
  reducers: {
    transferHistory(state, action) {
      state.history = action.payload;
    },
    beneficiary(state, action) {
      state.beneficiary = action.payload;
    },
    fetchRates(state, action) {
      state.fetchRates = action.payload;
    }
  }
});

export const reducer = slice.reducer;

export const transferHistory = (data = {}) => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);

    const response = await axios.post(`${url}transfer-credit-history/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });

    const { responseCode } = response.data;

    if (responseCode === '00') {
      const { returnedRecords } = response.data.responseData;

      dispatch(slice.actions.transferHistory(returnedRecords));
      dispatch(isLoading(false));
    } else {
      throw new Error();
    }
  } catch (error) {
    dispatch(isLoading(false));
    return error;
  }
};

export const existingBeneficiary = (data = {}) => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);

    const response = await axios.post(
      `${url}existing-beneficiaries-transfer-credit/`,
      data,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
    const { responseCode } = response.data;

    if (responseCode === '00') {
      const { returnedRecords } = response.data.responseData;

      dispatch(slice.actions.beneficiary(returnedRecords));
      dispatch(isLoading(false));
    } else {
      throw new Error();
    }
  } catch (error) {
    dispatch(isLoading(false));
    return error;
  }
};

export const transferCredit = (data) => async (dispatch) => {
  try {
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);

    const response = await axios.post(`${url}transfer-credit/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });
    const { responseCode, responseMessage } = response.data;

    if (responseCode === '00') {
      await dispatch(fetchUser());
      dispatch(alertSuccess(responseMessage));
    } else {
      throw new Error();
    }
  } catch (error) {
    dispatch(alertError(error.message));
    return error;
  }
};

export const fetchRates = (data) => async (dispatch) => {
  dispatch(isLoading(true));
  try {
    const { current_vzid } = JSON.parse(
      window.localStorage.getItem('current_store')
    );
    data.orgId = orgId;
    data.userGlobalId = atob(current_vzid);

    const response = await axios.post(`${url}service-rates/`, data, {
      headers: { 'Content-Type': 'application/json' }
    });

    const { responseCode } = response.data;

    if (responseCode === '00') {
      const { returnedRecords } = response.data.responseData;

      dispatch(slice.actions.fetchRates(returnedRecords));
      dispatch(isLoading(false));
    } else {
      throw new Error();
    }
  } catch (error) {
    dispatch(isLoading(false));
    dispatch(slice.actions.fetchRates([]));
    return error;
  }
};
